var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v(_vm._s(_vm.titleText.toUpperCase()))]),(_vm.highlightWord)?_c('div',{staticClass:"wordHighlight"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }